(ns frontend.view.settings2.surveys.timeseries.tab-history
  (:require [common.localization :as loc]
            [common.schema.entities.survey.timeseries :as timeseries]
            [frontend.view.settings2.surveys.events :as config-event]
            [re-frame.core :as rf]
            [ui.components.radio-group.view :as radio-group]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn view
  [{:keys [block-idx]} {:keys [history-in-use? snapshot-history? history]}]
  [:div
   {:class "flex flex-col gap-4"}
   [labelled-input/view
    {:label       (loc/tr :request-historical-data)
     :data-type   :data.type/boolean
     :horizontal? true
     :reverse?    true
     :editor-type :editor.type/toggle
     :value       (boolean history-in-use?)
     :on-change   (fn [v]
                    (rf/dispatch [::config-event/set-table-history-in-use? block-idx v]))}]
   [labelled-input/view
    {:label       (loc/tr :snapshot-data?)
     :data-type   :data.type/boolean
     :editor-type :editor.type/toggle
     :horizontal? true
     :reverse?    true
     :value       (boolean snapshot-history?)
     :disabled?   (not history-in-use?)
     :on-change   (fn [v]
                    (rf/dispatch [::config-event/set-table-history-snapshot? block-idx v]))}]
   (when history-in-use?
     [radio-group/radio-group-v2
      {:checked   history
       :on-change (fn [value]
                    (rf/dispatch [::config-event/set-table-history block-idx value]))}
      (->> timeseries/historical-options
           (mapv (fn [k]
                   {:value   k
                    :content (loc/tr k)})))])])
